import React from 'react';
import PropTypes from 'prop-types';
import Container from '../styled/Container';
import SecondHeader from '../styled/SecondHeader';
import Image from '../styled/Image';
import Paragraph from '../styled/Paragraph';

function OwnProfile({ authUser }) {
  return (
    <Container>
      <SecondHeader paddingbottom="20px" borderbottom="0">My Profile</SecondHeader>
      <Image height="90px" width="90px" src={authUser.avatar} alt={authUser.name} />
      <Paragraph>{authUser.name}</Paragraph>
    </Container>
  );
}

const userShape = {
  id: PropTypes.string,
  name: PropTypes.string,
  email: PropTypes.string,
  avatar: PropTypes.string,
};

OwnProfile.propTypes = {
  ...userShape,
};
export default OwnProfile;
